import React, { useContext, useEffect, useState } from 'react'
import { Card, CardBody, IconButton, Checkbox, Spinner } from "@material-tailwind/react";
import { BiEdit } from 'react-icons/bi';
import { Pagination, SearchAndAddBtn, Switch, THead } from '../../Components';
import { NewContext } from '../../Context/NewContext';
import { get__Blog_categories } from '../../Controller/actions';
import { RiDeleteBinLine } from 'react-icons/ri';
import BlogCategoriesModel from '../../Components/Modals/BlogCategoriesModel';


export const BlogCategories = ({ title }) => {
    const { permissions, tokenType, setDeleteUpdateTag, setDeleteUpdateItem, setAddEditDeleteTag, setFormData, deleteUpdateYes, confirmationModalShow, setConfirmationModalShow, handleSwitchUpdate, deleteUpdateTag, isLoading, checkedValues, handleCheckboxChange, currentPage, totalPage, perPage, search, setDeleteUpdateYes, setIsLoading, setCurrentPage, setPerPage, setTotalPage, currentPageData, setCurrentPageData, filterDropdown, handleOpen, isAscending, sortData } = useContext(NewContext);
    const simpleFields = [
        { name: "name", sortable: true, field: 'name' },
    ];
    const dropdownFields = [{ name: "Active" }];
    const totalFields = simpleFields.length + dropdownFields.length + 2;

    const getFontListData = async (_currentPage = 1, sortName = sortData, sortType = isAscending) => {
        setIsLoading(true);
        try {
            const getFontList = await get__Blog_categories(_currentPage, perPage, search, filterDropdown, sortName, sortType);
            if (getFontList) {
                const { status, data, currentPage, perPage, totalPage } = getFontList;
                if (status) {
                    setCurrentPageData(data);
                    setCurrentPage(currentPage);
                    setPerPage(perPage);
                    setTotalPage(totalPage);
                } else {
                    setCurrentPageData([]);
                }
            }
            setIsLoading(false);
        } catch (error) {
            console.error(error);
        }
    }

    const [pagePermissions, setPagePermissions] = useState({
        CU: true,
        R: true,
        D: true
    });

    useEffect(() => {
        getFontListData(currentPage, sortData, isAscending);
        setDeleteUpdateTag("")
    }, [deleteUpdateTag, search, perPage, filterDropdown, deleteUpdateYes, pagePermissions, sortData, isAscending]);

    useEffect(() => {
        if (tokenType === 'ldap') {
            const update = permissions?.subPermissions?.find((route) => route.name === 'Blog_Categories');
            setPagePermissions({ ...pagePermissions, CU: update?.CU, R: update?.R, D: update?.D })
        }
    }, [tokenType, permissions])

    useEffect(() => {
    }, [pagePermissions])


    useEffect(() => {
        document.title = title;
    }, [title])


    return (
        <>
            <SearchAndAddBtn title={`Blog Categories`} resetFilterBtn={false} addLink={false} addBtn={pagePermissions?.CU} deleteUpdateTag='all-delete-blog-categories' countryFilter={false} />
            <Card className="overflow-hidden w-full rounded-md shadow-none">
                <CardBody className="overflow-x-auto w-100 py-2.5 px-[5px] card-body-scrollbar">
                    <table className="w-full min-w-max table-auto text-left ">
                        <THead dropdownFields={dropdownFields} simpleFields={simpleFields} countryFilter={false} />
                        <tbody>
                            {
                                isLoading ?
                                    <tr>
                                        <td colSpan={totalFields} className='py-12'>
                                            <div className="flex justify-center items-center">
                                                <Spinner />
                                            </div>
                                        </td>
                                    </tr>
                                    : currentPageData?.length === 0 ?
                                        <tr>
                                            <td colSpan={totalFields} className='py-12 bg-gray-200'>
                                                <div className="flex justify-center items-center">
                                                    No Data Found
                                                </div>
                                            </td>
                                        </tr>
                                        : currentPageData?.map((_ele, i) => {
                                            const isLast = i === currentPageData?.length - 1;
                                            const classes = `text-[#1E1627] ${isLast ? "p-4" : "p-[14.5px]"}`;

                                            return (
                                                <tr key={i} className='border-b border-blue-gray-50'>
                                                    <td className={classes}>
                                                        <Checkbox
                                                            className='w-[18px] h-[18px] border-[1.5px] rounded-[3.6px] border-[#1E3354] checked:bg-[#0047FF] checked:border-transparent'
                                                            id={`slider-${_ele._id}`}
                                                            value={`${_ele._id}`}
                                                            disabled={!pagePermissions?.CU}
                                                            checked={checkedValues.includes(`${_ele._id}`)}
                                                            onChange={() => handleCheckboxChange(`${_ele._id}`)}
                                                        />
                                                    </td>

                                                    <td className={classes}>
                                                        <span className={`font-normal text-[17px] ${!_ele?.name && `text-gray-500`}`}>{_ele?.name || `none`}</span>
                                                    </td>

                                                    {
                                                        ["isActive"].map((_is_ele, i) => (
                                                            <td className={classes} key={i}>
                                                                <div className="ml-1">
                                                                    <Switch id={_ele._id} disabled={!pagePermissions?.CU} name={_is_ele} onChange={(e) => { setDeleteUpdateYes("update-blog-categories"); handleSwitchUpdate(e); }} checked={_ele[_is_ele]} />
                                                                </div>
                                                            </td>
                                                        ))
                                                    }
                                                    <td className={classes}>
                                                        <div className="flex items-center gap-2">
                                                            <IconButton disabled={!pagePermissions?.CU} className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none' onClick={() => { setDeleteUpdateYes("update-blog-categories"); setAddEditDeleteTag(`update`); setFormData(_ele); handleOpen() }}>
                                                                <BiEdit />
                                                            </IconButton>
                                                            <IconButton disabled={!pagePermissions?.D} className='bg-[#EAEDF3] text-[#F62929] text-[21px] shadow-none hover:shadow-none' onClick={() => { setDeleteUpdateYes("delete-blog-categories"); setDeleteUpdateItem({ id: _ele._id, name: _ele.name }); setConfirmationModalShow(!confirmationModalShow) }}>
                                                                <RiDeleteBinLine />
                                                            </IconButton>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                            }
                        </tbody>
                    </table>
                </CardBody>
            </Card>
            <Pagination currentPage={currentPage} totalPage={totalPage} getData={getFontListData} />
            <BlogCategoriesModel />
        </>
    )
}
BlogCategories.defaultProps = {
    title: "Message | Blog Categories"
};
export default BlogCategories;
